import { ProposalBlock, ProposalSection } from '@vzmi/shp_shared_compo'
import styles from './ProposalConsent.css'
import { isNewProductProposal } from '../../../../../lib/proposalHelper'

/** 同意書 */
const ProposalConsent = props => {
  const { proposalType } = props
  const isNewProduct = isNewProductProposal(proposalType)

  const title = '提案同意書'

  const shopInfoConsentTitle = `${
    isNewProduct
      ? '商品'
      : '賣場'
  }資訊確認`

  return (
    <ProposalSection
      title={title}
      data-role='proposal-consent'
    >
      <div className={styles.ProposalConsent}>
        <ProposalBlock className={styles.consentInfo}>
          <p>
            本公司於香港商雅虎資訊股份有限公司台灣分公司﹝以下簡稱貴公司﹞經營之「Yahoo!奇摩購物中心(http://buy.yahoo.com.tw/)」及其他銷售通路，擬就商品及圖片文字說明等內容自行提案於前述經營之網站網頁及其他銷售通路，本公司並同意貴公司之銷售對象無限制，包括且不限於個別消費者、公司行號團體等；銷售方式亦無限制，包括且不限於以網際網路方式、大量訂單專案另行議價等方式。本公司謹同意並遵守條款如下︰
          </p>
          <br />
          <br />
          <p>第一條 商品及行銷推廣</p>
          <br />
          <br />
          <p>
            一、本公司同意依照雙方簽訂之商品行銷推廣合約書之約定，由本公司提供所生產、製造、輸入、經銷、代理或銷售之商品(以下簡稱銷售商品)供貴公司銷售。
            {' '}
            <br />
            二、有關銷售商品之項目、型號、規格、進貨價格、數量等，詳見雙方間另外協議之文件，包括但不限於報價單、型錄、電子郵件、會議記錄等所載。
            {' '}
            <br />
            三、本公司提供貴公司銷售之商品，其進貨價格（含稅及運費）以本公司於貴公司SCM商品提案系統上之報價為準，但依商品屬性及促銷專案之不同，得由雙方以書面或其他方式協議調整進貨價格。又出售予消費者之售價以本公司於SCM商品提案系統上建議售價為參考依據，貴公司可依實際市場競爭狀況另行調整之。
            {' '}
            <br />
            四、本公司應隨時提供商品有關之最新訊息、技術支援等予貴公司。
            {' '}
            <br />
            五、除本公司自行就商品及圖片文字說明等內容提案外，本公司應提供銷售商品之簡介、規格、功能、圖片及相關說明等輔助銷售資料予貴公司，貴公司得於網站、電子媒體或其他廣告刊物上作商品宣傳廣告，並得接受本公司委託進行銷售商品之網頁製作，但廣告及網頁中之商品標示、內容、圖樣等，悉以本公司指定之內容為限。
            {' '}
            <br />
            六、為行銷推廣銷售商品之目的，本公司同意貴公司所製作之文宣、廣告上，使用本公司公司名稱、銷售商品名稱及商標。
            {' '}
            <br />
            七、為促進銷售，本公司同意貴公司得擇期舉辦商品之折扣或其他促銷活動，本公司同意以雙方議訂之特惠價格提供商品予貴公司銷售，並配合貴公司所擬定之行銷策略及計畫。
            <br />
            八、本公司保證其所提供貴公司銷售之商品，其價格及條件不得使貴公司較其他銷售相同商品之網站或店家處於劣勢地位。
            <br />
          </p>
          <br />
          <br />
          <p>第二條 產品保證與售後服務</p>
          <br />
          <br />
          <p>
            一、本公司保證所提供銷售之商品為新品且非贗品，並與商品型錄、說明書、廣告樣品或其他相關文件所示者相符。
            <br />
            二、本公司保證所提供銷售之商品本身及其標示、廣告內容等，符合消費者保護法、公平交易法、商品標示法、商標法、專利法、著作權法、食品衛生管理法、化妝品衛生管理條例、藥事法、菸害防制法及一切相關法令，如有違反，本公司及提案人需負擔法律責任及罰款。貴公司或員工若因此而遭受損失，需支付罰鍰、罰金、和解金或損害賠償..等相關費用，本公司亦同意承擔所有費用；且貴公司得要求本公司提供商品來源證明及其他足以證明商品及標示、廣告等符合法令規定之相關證明文件。
            <br />
            三、本公司同意對向貴公司購買本公司商品之消費者依民法、消費者保護法及相關法令之規定，以自己之費用配合貴公司辦理消費者退貨。
            <br />
            四、本公司對於本約消費者購買之商品，同意提供與一般消費者相同之瑕疵擔保、保固維修等售後服務。銷售商品如有故障、污損或其他瑕疵時，本公司同意以自己之費用，負責予以更換或退貨。
            <br />
            五、本公司如違約不負責新品更換或保固及售後服務者，則貴公司除得逕行終止本約外，本公司應給付該銷售商品貨款5倍之懲罰性違約金予貴公司，貴公司並得另行請求因此而支出之費用。
            <br />
            六、本公司因故停止生產、製造、輸入、經銷、代理或銷售商品時，仍應擔保原廠、進口商或其代理商對於所有向貴公司購買本公司商品之消費者，繼續提供銷售商品時所承諾之保固及售後服務，並履行其他於商品銷售時對消費者所為之所有承諾及應負之義務。
            <br />
            七、本公司同意依貴公司之要求，於銷售商品包裝附加貴公司所提供之標識及相關資料；除原廠包裝及其附隨資料外，非事先經貴公司同意，本公司不得於商品包裝之內外，附加或夾帶非貴公司同意之任何行銷資料；本公司並保證銷售商品之包裝除本公司或貴公司之公司名稱、商標外，不得有其他公司之名稱、商標或其他使人誤認該銷售商品係來自其他銷售通路之文字或圖樣。
            <br />
          </p>
          <br />
          <br />
          <p>第三條 智慧財產權</p>
          <br />
          <br />
          <p>
            一、本公司保證銷售商品及授權貴公司刊登型錄之商標及相關資料，並無侵害他人之著作權、專利權、商標及其他智慧財產權之情事。如有違反，本公司應承擔一切責任及損失；貴公司如因此而遭受損失或支出費用（包含但不限於罰鍰、罰金、賠償金、訴訟費、律師費等），亦由本公司負擔。
            <br />
            二、為確保本公司符闔第一項之規定，貴公司如需本公司提供證明文件或配合措施時，本公司同意遵照辦理。
            <br />
          </p>
          <br />
          <br />
          <p>第四條 特別品類商品</p>
          <br />
          <br />
          <p>
            一、茲因本公司商品涉及食品、健康食品、化妝品、醫療器材、藥品或其他特別品類商品其需要接受食品衛生管理法、健康食品管理法、化粧品衛生管理條例、藥事法或其他類似法律特別規定與管理者，特製訂本條款。
            <br />
            二、本公司所提供商品其輸入、廣告與銷售，如依相關法令須向主管機關申請核准，本公司應依法如實申辦並提供核准資料（包括相關證號）供貴公司查驗並存底。本公司不得有未申請相關核准字號、擅自更改已核准廣告內容、宣稱具有療效或誇大不實，或有其他標示或法定程式之欠缺等情事。
            <br />
          </p>
          <br />
          <br />
          <p>第五條 消費糾紛之解決</p>
          <br />
          <br />
          <p>
            一、消費者因購買銷售商品發生消費糾紛時，貴公司得要求本公司出面協助處理、解決之，本公司不得拖延、拒絕。
            <br />
            二、本公司應依民法、消費者保護法及其他相關法令之規定，對消費者負責。
            <br />
            三、本公司應依相關法令規定或產業慣例為其所提供商品投保產品責任保險。若消費者因食用或使用本公司所提供商品，致使消費者身心受到損害，本公司應承擔一切責任及損失。
            <br />
          </p>
          <br />
          <br />
          <p>第六條 保密義務</p>
          <br />
          <br />
          <p>
            一、本公司對於本條款之內容及因本條款所知悉或持有貴公司之營業秘密及未公開之資料，均應負保密之義務。除依法令規定或依有權機關之要求而對該機關提供者外，不得以任何方式提供或洩露予第三人，亦不得轉作其他目的使用；本條款終止二年後亦同。
            <br />
            二、本公司於條款期間取得貴公司相關文件、報表、銷售資料、ＳＣＭ系統或其他電子公告之相關資料、消費者個人資料及交易記錄等，均視為貴公司之營業秘密，除事先經貴公司書面同意外，本公司不得提供或洩漏予任何第三人，亦不得為本條款以外其他目的之使用；本條款終止二年後亦同。
            <br />
            三、本公司違反本條之約定時，除應自負法律責任外，如因此而致貴公司、貴公司負責人或貴公司員工受司法機關調查、追訴或遭第三人主張權利時，貴公司得要求本公司出面處理善後事宜，並提供必要之說明、證據或為其他協助，貴公司並得逕行終止本條款；如貴公司、貴公司負責人或貴公司員工因此而受有損害或支付相關費用(包括但不限於訴訟費、律師費、罰鍰、罰金、和解金或損害賠償等)，本公司並應負賠償之責。
            <br />
          </p>
          <br />
          <br />
          <p>第七條 重大違約之處理</p>
          <br />
          <br />
          <p>
            本公司如違反本約第二條、第四條第二項、第五條第三項之約定時，除應自負法律責任外，如因此而致貴公司、貴公司負責人或貴公司員工受司法、行政機關調查、追訴、處分或遭第三人主張權利時，貴公司得要求本公司提供必要之說明、證據或為其他協助，貴公司並得逕行終止本合約；如貴公司、貴公司負責人或貴公司員工因此而受有損害或支付相關費用(包括但不限於訴訟費、律師費、罰鍰、罰金、和解金或損害賠償等)，本公司應負賠償或給付之責。本公司並同意，前述金額，貴公司得逕自本公司之貨款中扣抵。
            <br />
          </p>
          <br />
          <br />
          <p>第八條、其他規定</p>
          <br />
          <br />
          <p>
            本公司履行本合約之行為如有致使貴公司、貴公司負責人或員工受政府機關調查或追訴、或受第三人主張權利者，經貴公司認定有受損害之虞時，本公司同意貴公司得就本公司得請領之貨款，於貴公司認定可能受損害之金額範圍內，暫予保留，俟上開情事確定後，再依本合約相關規定處理。
            <br />
          </p>
        </ProposalBlock>
      </div>
      <div className={styles.shopInfoConsent}>
        <h4>{shopInfoConsentTitle}</h4>
        <span>請確認以下資訊無誤後，再儲存/送出檔案</span>
      </div>
    </ProposalSection>
  )
}

export default ProposalConsent
